export var PurchaseIntent;
(function (PurchaseIntent) {
    PurchaseIntent["FirstHome"] = "FIRST_HOME";
    PurchaseIntent["NextHome"] = "NEXT_HOME";
    PurchaseIntent["Investment"] = "INVESTMENT";
})(PurchaseIntent || (PurchaseIntent = {}));
//# sourceMappingURL=index.js.map